import { core, semantic } from '@diligentcorp/atlas-design-tokens/lens';

// Extract the raw string value from a package token object.
const v = (token: { value: string }) => token.value;

export const atlasCore = {
  color: {
    gray: {
      0: v(core.color.gray[0]),
      50: v(core.color.gray[50]),
      100: v(core.color.gray[100]),
      200: v(core.color.gray[200]),
      300: v(core.color.gray[300]),
      400: v(core.color.gray[400]),
      500: v(core.color.gray[500]),
      600: v(core.color.gray[600]),
      700: v(core.color.gray[700]),
      800: v(core.color.gray[800]),
      900: v(core.color.gray[900]),
      950: v(core.color.gray[950]),
      1000: v(core.color.gray[1000]),
    },
    red: {
      10: v(core.color.red[10]),
      20: v(core.color.red[20]),
      25: v(core.color.red[25]),
      30: v(core.color.red[30]),
      35: v(core.color.red[35]),
      40: v(core.color.red[40]),
      50: v(core.color.red[50]),
      60: v(core.color.red[60]),
      70: v(core.color.red[70]),
      80: v(core.color.red[80]),
      90: v(core.color.red[90]),
      95: v(core.color.red[95]),
      98: v(core.color.red[98]),
    },
    green: {
      10: v(core.color.green[10]),
      20: v(core.color.green[20]),
      25: v(core.color.green[25]),
      30: v(core.color.green[30]),
      35: v(core.color.green[35]),
      40: v(core.color.green[40]),
      50: v(core.color.green[50]),
      60: v(core.color.green[60]),
      70: v(core.color.green[70]),
      80: v(core.color.green[80]),
      90: v(core.color.green[90]),
      95: v(core.color.green[95]),
      98: v(core.color.green[98]),
    },
    yellow: {
      10: v(core.color.yellow[10]),
      20: v(core.color.yellow[20]),
      25: v(core.color.yellow[25]),
      30: v(core.color.yellow[30]),
      35: v(core.color.yellow[35]),
      40: v(core.color.yellow[40]),
      50: v(core.color.yellow[50]),
      60: v(core.color.yellow[60]),
      70: v(core.color.yellow[70]),
      80: v(core.color.yellow[80]),
      90: v(core.color.yellow[90]),
      95: v(core.color.yellow[95]),
      98: v(core.color.yellow[98]),
    },
    blue: {
      10: v(core.color.blue[10]),
      20: v(core.color.blue[20]),
      25: v(core.color.blue[25]),
      30: v(core.color.blue[30]),
      35: v(core.color.blue[35]),
      40: v(core.color.blue[40]),
      50: v(core.color.blue[50]),
      60: v(core.color.blue[60]),
      70: v(core.color.blue[70]),
      80: v(core.color.blue[80]),
      90: v(core.color.blue[90]),
      95: v(core.color.blue[95]),
      98: v(core.color.blue[98]),
    },
    purple: {
      10: v(core.color.purple[10]),
      20: v(core.color.purple[20]),
      25: v(core.color.purple[25]),
      30: v(core.color.purple[30]),
      35: v(core.color.purple[35]),
      40: v(core.color.purple[40]),
      50: v(core.color.purple[50]),
      60: v(core.color.purple[60]),
      70: v(core.color.purple[70]),
      80: v(core.color.purple[80]),
      90: v(core.color.purple[90]),
      95: v(core.color.purple[95]),
    },
    indigo: {
      10: v(core.color.indigo[10]),
      15: v(core.color.indigo[15]),
      20: v(core.color.indigo[20]),
      25: v(core.color.indigo[25]),
      30: v(core.color.indigo[30]),
      35: v(core.color.indigo[35]),
      40: v(core.color.indigo[40]),
      50: v(core.color.indigo[50]),
      60: v(core.color.indigo[60]),
      70: v(core.color.indigo[70]),
      80: v(core.color.indigo[80]),
      90: v(core.color.indigo[90]),
      95: v(core.color.indigo[95]),
    },
    flamingo: {
      20: v(core.color.flamingo[20]),
      30: v(core.color.flamingo[30]),
      40: v(core.color.flamingo[40]),
      50: v(core.color.flamingo[50]),
      60: v(core.color.flamingo[60]),
      70: v(core.color.flamingo[70]),
      80: v(core.color.flamingo[80]),
      90: v(core.color.flamingo[90]),
      95: v(core.color.flamingo[95]),
    },
    concrete: {
      80: v(core.color.concrete[80]),
      90: v(core.color.concrete[90]),
      95: v(core.color.concrete[95]),
    },
    brand: {
      diligentRed: v(core.color.brand.primary.diligentRed),
      red2: v(core.color.brand.primary.red2),
      red3: v(core.color.brand.primary.red3),
      red4: v(core.color.brand.primary.red4),
      red5: v(core.color.brand.primary.red5),
      blue1: v(core.color.brand.secondary.blue1),
      blue2: v(core.color.brand.secondary.blue2),
      blue3: v(core.color.brand.secondary.blue3),
      purple1: v(core.color.brand.secondary.purple1),
      purple2: v(core.color.brand.secondary.purple2),
      purple3: v(core.color.brand.secondary.purple3),
      gray1: v(core.color.brand.neutral.gray1),
      gray2: v(core.color.brand.neutral.gray2),
      gray3: v(core.color.brand.neutral.gray3),
      gray4: v(core.color.brand.neutral.gray4),
      gray5: v(core.color.brand.neutral.gray5),
    },
  },
  spacing: {
    0: v(core.spacing[0]),
    px: v(core.spacing.px),
    '0_25': v(core.spacing['0_25']),
    '0_5': v(core.spacing['0_5']),
    1: v(core.spacing[1]),
    '1_5': v(core.spacing['1_5']),
    2: v(core.spacing[2]),
    '2_5': v(core.spacing['2_5']),
    3: v(core.spacing[3]),
    4: v(core.spacing[4]),
    '4_5': v(core.spacing['4_5']),
    5: v(core.spacing[5]),
    6: v(core.spacing[6]),
    7: v(core.spacing[7]),
    8: v(core.spacing[8]),
    9: v(core.spacing[9]),
  },
  radius: {
    none: '0px',
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '24px',
    '2xl': '36px',
    full: '9999px',
  },
  shadow: {
    low: core.shadow.low.value.stringValue,
    medium: core.shadow.medium.value.stringValue,
    high: core.shadow.high.value.stringValue,
  },
} as const;

export const atlasSemantic = {
  color: {
    action: {
      primary: {
        default: v(semantic.color.action.primary.default),
        hover: v(semantic.color.action.primary.hover),
        active: v(semantic.color.action.primary.active),
        disabled: v(semantic.color.action.primary.disabled),
        onPrimary: v(semantic.color.action.primary.onPrimary),
        onPrimaryDisabled: v(semantic.color.action.primary.onPrimaryDisabled),
      },
      secondary: {
        outline: v(semantic.color.action.secondary.outline),
        hoverFill: v(semantic.color.action.secondary.hoverFill),
        activeFill: v(semantic.color.action.secondary.activeFill),
        disabledOutline: v(semantic.color.action.secondary.disabledOutline),
        onSecondary: v(semantic.color.action.secondary.onSecondary),
      },
      destructive: {
        default: v(semantic.color.action.destructive.default),
        hover: v(semantic.color.action.destructive.hover),
        active: v(semantic.color.action.destructive.active),
        disabled: v(semantic.color.action.destructive.disabled),
        onDestructive: v(semantic.color.action.destructive.onDestructive),
      },
      link: {
        default: v(semantic.color.action.link.default),
        hover: v(semantic.color.action.link.hover),
        active: v(semantic.color.action.link.active),
        disabled: v(semantic.color.action.link.disabled),
      },
      secondaryInverse: {
        hover: v(semantic.color.action.secondaryInverse.hover),
        active: v(semantic.color.action.secondaryInverse.active),
        selected: v(semantic.color.action.secondaryInverse.selected),
        onSelected: v(semantic.color.action.secondaryInverse.onSelected),
        onSecondaryInverse: v(
          semantic.color.action.secondaryInverse.onSecondaryInverse,
        ),
        onSecondaryInverseDisabled: v(
          semantic.color.action.secondaryInverse.onSecondaryInverseDisabled,
        ),
        highlighted: v(semantic.color.action.secondaryInverse.highlighted),
        selectionIndicator: v(
          semantic.color.action.secondaryInverse.selectionIndicator,
        ),
        outlineDisabled: v(
          semantic.color.action.secondaryInverse.outlineDisabled,
        ),
        selectionIndicatorTabs: v(
          semantic.color.action.secondaryInverse.selectionIndicatorTabs,
        ),
      },
    },
    type: {
      default: v(semantic.color.type.default),
      muted: v(semantic.color.type.muted),
      disabled: v(semantic.color.type.disabled),
      inverse: v(semantic.color.type.inverse),
    },
    background: {
      base: v(semantic.color.background.base),
      container: v(semantic.color.background.container),
      navSelection: v(semantic.color.background.navSelection),
      backdrop: v(semantic.color.background.backdrop),
    },
    surface: {
      default: v(semantic.color.surface.default),
      variant: v(semantic.color.surface.variant),
      subtle: v(semantic.color.surface.subtle),
      inverse: v(semantic.color.surface.inverse),
    },
    outline: {
      fixed: v(semantic.color.outline.fixed),
      default: v(semantic.color.outline.default),
      hover: v(semantic.color.outline.hover),
      active: v(semantic.color.outline.active),
      disabled: v(semantic.color.outline.disabled),
    },
    ui: {
      focusRing: v(semantic.color.ui.focusRing),
      focusInverse: v(semantic.color.ui.focusInverse),
      loading: {
        default: v(semantic.color.ui.loading.default),
        variant: v(semantic.color.ui.loading.variant),
      },
      divider: {
        default: v(semantic.color.ui.divider.default),
        secondary: v(semantic.color.ui.divider.secondary),
      },
      scrollbar: {
        handle: v(semantic.color.ui.scrollbar.handle),
      },
    },
    status: {
      success: {
        default: v(semantic.color.status.success.default),
        background: v(semantic.color.status.success.background),
        text: v(semantic.color.status.success.text),
        backgroundInverse: '#0f412b',
        textInverse: '#cff0c3',
        textDefault: v(semantic.color.status.success.textDefault),
      },
      warning: {
        default: v(semantic.color.status.warning.default),
        background: v(semantic.color.status.warning.background),
        text: v(semantic.color.status.warning.text),
      },
      error: {
        default: v(semantic.color.status.error.default),
        background: v(semantic.color.status.error.background),
        text: v(semantic.color.status.error.text),
        backgroundInverse: '#441217',
        textInverse: '#ffe9e7',
      },
      notification: {
        default: v(semantic.color.status.notification.default),
        background: v(semantic.color.status.notification.background),
        text: v(semantic.color.status.notification.text),
        textDefault: v(semantic.color.status.notification.textDefault),
      },
      new: {
        default: v(semantic.color.status.new.default),
        textDefault: v(semantic.color.status.new.textDefault),
      },
      neutral: {
        background: v(semantic.color.status.neutral.background),
        textDefault: v(semantic.color.status.neutral.textDefault),
        backgroundVariant: v(semantic.color.status.neutral.backgroundVariant),
        text: v(semantic.color.status.neutral.text),
      },
    },
    selection: {
      primary: {
        default: v(semantic.color.selection.primary.default),
        hover: v(semantic.color.selection.primary.hover),
        active: v(semantic.color.selection.primary.active),
        onSelected: v(semantic.color.selection.primary.onSelected),
      },
      secondary: {
        default: v(semantic.color.selection.secondary.default),
        hover: v(semantic.color.selection.secondary.hover),
        active: v(semantic.color.selection.secondary.active),
      },
    },
    accent: {
      red: {
        background: v(semantic.color.accent.red.background),
        content: v(semantic.color.accent.red.content),
      },
      yellow: {
        background: v(semantic.color.accent.yellow.background),
        content: v(semantic.color.accent.yellow.content),
      },
      green: {
        background: v(semantic.color.accent.green.background),
        content: v(semantic.color.accent.green.content),
      },
      blue: {
        background: v(semantic.color.accent.blue.background),
        content: v(semantic.color.accent.blue.content),
      },
      purple: {
        background: v(semantic.color.accent.purple.background),
        content: v(semantic.color.accent.purple.content),
      },
    },
    dataVisualization: {
      qualitative: {
        blue: {
          '01': v(semantic.color.dataVisualization.qualitative.blue['01']),
          '02': v(semantic.color.dataVisualization.qualitative.blue['02']),
          '03': v(semantic.color.dataVisualization.qualitative.blue['03']),
          '04': v(semantic.color.dataVisualization.qualitative.blue['04']),
        },
        purple: {
          '01': v(semantic.color.dataVisualization.qualitative.purple['01']),
          '02': v(semantic.color.dataVisualization.qualitative.purple['02']),
          '03': v(semantic.color.dataVisualization.qualitative.purple['03']),
          '04': v(semantic.color.dataVisualization.qualitative.purple['04']),
        },
        gray: {
          '01': v(semantic.color.dataVisualization.qualitative.gray['01']),
          '02': v(semantic.color.dataVisualization.qualitative.gray['02']),
          '03': v(semantic.color.dataVisualization.qualitative.gray['03']),
          '04': v(semantic.color.dataVisualization.qualitative.gray['04']),
        },
      },
      sequential: {
        positive: {
          '01': v(semantic.color.dataVisualization.sequential.positive['01']),
          '02': v(semantic.color.dataVisualization.sequential.positive['02']),
          '03': v(semantic.color.dataVisualization.sequential.positive['03']),
          '04': v(semantic.color.dataVisualization.sequential.positive['04']),
          '05': v(semantic.color.dataVisualization.sequential.positive['05']),
        },
        negative: {
          '01': v(semantic.color.dataVisualization.sequential.negative['01']),
          '02': v(semantic.color.dataVisualization.sequential.negative['02']),
          '03': v(semantic.color.dataVisualization.sequential.negative['03']),
          '04': v(semantic.color.dataVisualization.sequential.negative['04']),
          '05': v(semantic.color.dataVisualization.sequential.negative['05']),
        },
        neutral: {
          '01': v(semantic.color.dataVisualization.sequential.neutral['01']),
          '02': v(semantic.color.dataVisualization.sequential.neutral['02']),
          '03': v(semantic.color.dataVisualization.sequential.neutral['03']),
          '04': v(semantic.color.dataVisualization.sequential.neutral['04']),
          '05': v(semantic.color.dataVisualization.sequential.neutral['05']),
        },
      },
      rag: {
        positive: {
          '01': v(semantic.color.dataVisualization.rag.positive['01']),
          '02': v(semantic.color.dataVisualization.rag.positive['02']),
          '03': v(semantic.color.dataVisualization.rag.positive['03']),
          '04': v(semantic.color.dataVisualization.rag.positive['04']),
          '05': v(semantic.color.dataVisualization.rag.positive['05']),
        },
        negative: {
          '01': v(semantic.color.dataVisualization.rag.negative['01']),
          '02': v(semantic.color.dataVisualization.rag.negative['02']),
          '03': v(semantic.color.dataVisualization.rag.negative['03']),
          '04': v(semantic.color.dataVisualization.rag.negative['04']),
          '05': v(semantic.color.dataVisualization.rag.negative['05']),
        },
        neutral: {
          '01': v(semantic.color.dataVisualization.rag.neutral['01']),
          '02': v(semantic.color.dataVisualization.rag.neutral['02']),
          '03': v(semantic.color.dataVisualization.rag.neutral['03']),
          '04': v(semantic.color.dataVisualization.rag.neutral['04']),
          '05': v(semantic.color.dataVisualization.rag.neutral['05']),
        },
      },
      chart: {
        blue: '#0086fa',
        yellow: '#e5a500',
        red: '#e6005c',
        green: '#31ee2e',
        pink: '#f45695',
        teal: '#00d3f3',
        violet: '#642fcf',
        yellow2: '#f5cc00',
      },
    },
  },
  shadow: {
    focus: semantic.shadow.focus.value.stringValue,
    focusInset: semantic.shadow.focusInset.value.stringValue,
  },
  radius: {
    none: v(semantic.radius.none),
    sm: v(semantic.radius.sm),
    md: v(semantic.radius.md),
    lg: v(semantic.radius.lg),
    xl: v(semantic.radius.xl),
    '2xl': v(semantic.radius['2xl']),
    full: v(semantic.radius.full),
  },
} as const;

export type AtlasCore = typeof atlasCore;
export type AtlasSemantic = typeof atlasSemantic;
